import type { ServiceCategoryFilter } from "../components/services/mockData";
import {
  ANALYTICS_TABS,
  DEFAULT_ANALYTICS_TAB,
  isAnalyticsTab,
  type AnalyticsTab,
} from "@/components/pages/analytics/config/analyticsTabs";

export const ANALYTICS_FD_TABS = ANALYTICS_TABS;
export type AnalyticsFdTab = AnalyticsTab;
export const DEFAULT_ANALYTICS_FD_TAB: AnalyticsFdTab = DEFAULT_ANALYTICS_TAB;
export const isAnalyticsFdTab = isAnalyticsTab;

const SERVICE_CATEGORY_FILTERS: ServiceCategoryFilter[] = [
  "all",
  "guestServices",
  "activities",
  "externalServices",
  "guesteriaPartners",
];

export function isServiceCategoryFilter(
  value: string,
): value is ServiceCategoryFilter {
  return SERVICE_CATEGORY_FILTERS.includes(value as ServiceCategoryFilter);
}

export function parseServiceCategoryFilter(
  raw: string | null,
): ServiceCategoryFilter {
  if (raw && isServiceCategoryFilter(raw)) {
    return raw;
  }

  return "all";
}
